import React, { useId, useState } from "react";
import { Icon } from "react-icons-kit";
import { ic_keyboard_arrow_down } from "react-icons-kit/md/ic_keyboard_arrow_down";
import { ic_keyboard_arrow_right } from "react-icons-kit/md/ic_keyboard_arrow_right";

export function CollapsibleSection({ title, defaultOpen, children }: { title: string; defaultOpen: boolean; children: React.ReactNode }) {
    const [open, setOpen] = useState(defaultOpen);
    const contentId = useId();
    return (
        <div className={`rounded-lg border ${open ? "border-dark-green" : "border-field-outline"} overflow-hidden transition-colors`}>
            <button
                onClick={() => setOpen(!open)}
                className={`w-full flex items-center gap-2 px-4 py-3 text-sm font-semibold transition-colors ${open ? "bg-light-green text-dark-green" : "bg-very-light-gray text-secondary-gray hover:text-dark-green"}`}
                type="button"
                aria-expanded={open}
                aria-controls={contentId}
            >
                <Icon icon={open ? ic_keyboard_arrow_down : ic_keyboard_arrow_right} size={20} />
                <span>{title}</span>
            </button>
            {open && <div id={contentId} className="bg-white">{children}</div>}
        </div>
    );
}
